import t from"react";import{StyledWrapper as e}from"./styles.js";const r=({children:r,testId:a="rounded-wrapper",...d})=>t.createElement(e,{"data-testid":a,...d},r);export{r as default};
//# sourceMappingURL=RoundedWrapper.js.map
